
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/demo-confirmation",
      function () {
        return require("private-next-pages/demo-confirmation.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/demo-confirmation"])
      });
    }
  